export const faqArray = [
	{
		"id": 1,
		"question" : "What is GST PayLater?",
		"answer" : "<p>GST PayLater is a hassle-free, instant and low interest credit line for GST payment to make sure you never miss any GST payment deadline due to limited cash flow.</p>"
	},
	{
		"id": 2,
		"question" : "What are the key benefits of GST PayLater?",
		"answer" : "<p>This credit line will help in following</p><ul><li>Pay Taxes on time, maintain a good compliance history Instant, on-demand credit line enables you to pay your taxes on time</li><li>Competitive interest rates GST PayLater is available at competitive interest rates starting at 1% per month</li><li>Invest available cash in your business. GST Payments can feel untimely when you may have an urgent purchase order or a customer order to rather work on</li><li>Collateral free. We don't ask for any collateral.</li><li>No usage, No interest. You pay only what you use. Interest is charged only on the amount utilised to pay taxes.</li><li>Safe and secure. We share your data with banks only with your consent. We have partnered with RBI registered and audited lending platforms.</li><li>Credit limit valid for one year. Once your credit line is activated, it is valid for one year</li></ul>"
	},
	{
		"id": 3,
		"question" : "How to register for GST PayLater?",
		"answer" : "<p>Go to <a href='www.clearcapital.cleartax.in' target='_blank'>www.clearcapital.cleartax.in<a></p><p>Step 1: Create your account and enter your profile details</p><p>Step 2: Download your GST data</p><p>Step 3: Generate loan offer</p><p>Step 4: Complete KYC, eNACH, eSign agreement to complete your application </p><p>Step 5: Upload your challan, get it disbursed </p>"
	},
	{
		"id": 4,
		"question" : "What documents will I need to apply for this loan?",
		"answer" : "<p>a. KYC documents which includes valid address proof</p><p>b. Business registration proof</p><p>c. PAN card</p>"
	},
	{
		"id": 5,
		"question" : "What is the interest rate and when can I repay?",
		"answer" : "<p>Interest rates ranging from 1% to 2% per month will be applicable on the basis of credit profile. The details about the interest cost payable will be communicated to you along with the approval of the credit limit requested and will be available on your GST PayLater dashboard.</p>"
	},
	{
		"id": 6,
		"question" : "How will the loan amount be disbursed?",
		"answer" : "<p>Your challan will be paid to your electronic cash ledger of the GSTN or gov portal via a valid challan number.</p>"
	}
]